export default {
  name: 'marking--docH',
  apiService: 'shoes',
  apiPath: '/admin/doc_h',
};